import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { takeWhile} from 'rxjs/operators';
import { Subject } from 'rxjs';
import { CountryPictures } from '../../../../@core/data/country-picture';
import { Router } from '@angular/router';
import { CountryInformationService } from '../../../../@core/mock/country-information.service';
import { CountryService } from '../../../../@core/mock/country.service';
import { NbWindowService } from '@nebular/theme';


@Component({
  selector: 'ngx-country-pictures',
  styleUrls: ['./country-pictures.component.scss'],
  templateUrl: './country-pictures.component.html',
})
export class CountryPicturesComponent implements OnInit, OnDestroy {

  @ViewChild('contentTemplate', { static: true }) contentTemplate: TemplateRef<any>;
  @ViewChild('disabledEsc', { read: TemplateRef, static: true }) disabledEscTemplate: TemplateRef<HTMLElement>;
  
  private destroy$ = new Subject<void>();

  private alive = true;

  cameras : CountryPictures[];
  selectedCamera: CountryPictures;
  
  debutLien = 'assets/country-informations/';
  finLien = '-information.json';
  lienInfo: string;
  countryName: string = '';
  countryType: string = '';
  isSingleView = false;


  constructor(private route: Router,
    private countryInformationService: CountryInformationService,
    private countryService: CountryService,
    private windowService: NbWindowService,) {
      
      this.countryName = this.route.getCurrentNavigation().extras.state.countryName;
      if (this.route.getCurrentNavigation().extras.state.countryType === ''){
        this.countryType = this.countryService.changeNameToType(this.countryName);
      } else this.countryType = this.route.getCurrentNavigation().extras.state.countryType;
      this.lienInfo = this.debutLien + this.countryType + this.finLien;
      this.countryInformationService.getInformationJson(this.lienInfo)
      .pipe(takeWhile(() => this.alive))
      .subscribe((jsonInfo) => {
        this.cameras = jsonInfo.pointInteret;
        console.log("camera vue", this.cameras);

      });
      console.log(" camera information", this.countryType, ' / ', this.countryName, ' / ', this.lienInfo);
  }
  openWindow(contentTemplate) {
    this.windowService.open(
      contentTemplate,
      {
        title: 'Window content from template',
        context: {
          text: 'some text to pass into template',
        },
      },
    );
  }
  ngOnInit(){
    
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  selectCamera(camera: any) {
    this.selectedCamera = camera;
    this.isSingleView = true;
  }
}
